var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st4",
    d: "M71.98,44.47H56.5V28.99c0-2.38-1.93-4.32-4.32-4.32H48.7c-2.38,0-4.32,1.93-4.32,4.32v15.47H28.91 c-2.38,0-4.32,1.93-4.32,4.32v3.49c0,2.38,1.93,4.32,4.32,4.32h15.47v15.47c0,2.38,1.93,4.32,4.32,4.32h3.49 c2.38,0,4.32-1.93,4.32-4.32V56.59h15.47c2.38,0,4.32-1.93,4.32-4.32v-3.49C76.29,46.4,74.36,44.47,71.98,44.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.67b5d761f4b8a739a92f387712dfc034.svg";
export { ForwardRef as ReactComponent };